
import { useMutation, useQuery } from "react-query"
import { useNavigate } from "react-router-dom";
import { useToast } from "../../hooks/usetoast";
import DataService from '../../config/DataServices'

const { getRequest, postRequest } = DataService()


export const useSignin = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("/auth/login", { ...data })
        },
        onSuccess: (success) => {
            if (success?.data?.status) {
                return toast.success(success?.data?.message)
            }
            return toast.error(success?.data?.message)

        },
        select: res => res?.data
    })
}

export const useSignOut = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: () => {
            return postRequest("/auth/logout")
        },
        onError: (error) => {
            return toast.error(error?.message)
        },
        onSuccess: success => {
            if (success?.data?.status) {
                return toast.success(success?.data?.message)
            }
            return toast.error(success?.data?.message)

        },
    })
}

export const useSigninTFA = () => {


    return useMutation({
        mutationFn: data => {
            return postRequest("/auth/2fa/verify", { ...data })
        },
    })
}

// Forgot Password
export const useForgotPass = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("/auth/forgot-password", { ...data })
        },
        onError: error => {
            return toast.error(error?.message)
        },
        onSuccess: success => {
            return toast.success(success?.data?.message)
        }
    })
}

export const useForgotPattern = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("/auth/forgot-pattern", { ...data })
        },
        onError: error => {
            return toast.error(error?.message)
        },
        onSuccess: success => {
            return toast.success(success?.data?.message)
        }
    })
}

export const useResetPass = () => {
    const toast = useToast();
    const navigate = useNavigate()

    return useMutation({
        mutationFn: data => {
            return postRequest("/auth/reset-password", { ...data })
        },
        onError: error => {
            toast.error(error?.message)
            return navigate('/')
        },
        onSuccess: success => {
            toast.success(success?.data?.message)
            return navigate('/')
        }
    })
}

export const useResetPattern = () => {
    const toast = useToast();
    const navigate = useNavigate()

    return useMutation({
        mutationFn: data => {
            return postRequest("/auth/reset-pattern", { ...data })
        },
        onError: error => {
            toast.error(error?.message)
            return navigate('/')
        },
        onSuccess: success => {
            toast.success(success?.data?.message)
            return navigate('/')
        }
    })
}

export const useAddWhitelist = () => {
    const toast = useToast();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: async (data) => {
            const response = await postRequest('/auth/whitelist-ip', {
                whitelistCode: data,
            });
            return response;
        },
        onError: (error) => {
            navigate('/');
            toast.error(error?.message);
        },
        onSuccess: (result) => {
            toast.success(result?.message || 'Whitelist added successfully');
            navigate('/');
        },
    });
};



export const useCheckLink = () => {

    return useQuery({
        queryKey: ['check-ip'],
        queryFn: (data) => {
            return getRequest('/auth/ip-status', data);
        },

    });
};


const checkUrl = (checkUrlData) => {
    if (checkUrlData?.url === 'reset-pattern') {
        return postRequest('/auth/verify-pattern-reset-token', { token: checkUrlData.token })
    }
    return postRequest('/auth/verify-password-reset-token', { token: checkUrlData.token })
}

export const useExpiredlink = () => {
    const toast = useToast()
    const navigate = useNavigate()
    return useMutation(checkUrl, {
        onError: (error) => {
            toast.error(error?.message)
            navigate('/')
        }
    })
}
